// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"56":"politica","223":"channels","486":"bcompliance","717":"email","915":"empresas"}[chunkId] || chunkId) + "." + {"56":"7edf1e76","223":"e8514a74","486":"000528eb","717":"8a512d6c","896":"ef355abc","915":"5dcb1d1c"}[chunkId] + ".js";
};